import axios from 'axios';

import config from '../config';

export const instance = () => {
  return axios.create({
    baseURL: config.API_URL,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('react-token')}`,
    },
  });
};

// Instancia para hap-orders-api (catálogo/pedidos). Reusa el token de Keycloak.
// La org seleccionada viaja como `?idOrganization=` (misma convención que el resto
// de la app): la API la valida contra el token y solo super-admin puede pedir otra.
export const ordersInstance = (idOrganization?: string) => {
  return axios.create({
    baseURL: config.ORDERS_API_URL,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('react-token')}`,
    },
    params: idOrganization ? {idOrganization} : undefined,
  });
};
